require('./angular');
module.exports = angular;


/*** EXPORTS FROM exports-loader ***/
module.exports = window.angular;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular/index.js
// module id = 1
// module chunks = 1